import { AspectRatio } from "@/components/ui/aspect-ratio";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { PlaceholderImage } from "@/components/common/placeholder-image";

export default function MobileCard(props: any) {
  const { isSelected, image_link, name, title, description, year } = props;

  if (isSelected)
    return (
      <div className="">
        <AspectRatio ratio={84 / 71} className={cn("relative")}>
          {image_link ? (
            <div className="">
              <Image src={image_link} objectFit="cover" fill alt={name} />
            </div>
          ) : (
            <PlaceholderImage />
          )}
        </AspectRatio>
        <div className="absolute pt-10">
          <h1 className="text-4xl -tracking-[0.03em] text-secondary 2xl:text-6xl ltr:font-playfair">
            {name}
          </h1>
          <p className="py-2 text-xl ltr:font-sans"> {`${title} - ${year}`}</p>
          <p className="max-w-sm pt-4 text-base leading-[24px] text-secondary/60 2xl:max-w-md 2xl:pt-8 2xl:text-xl 2xl:leading-[32px]">
            {description}
          </p>
        </div>
      </div>
    );

  return (
    <AspectRatio ratio={100 / 71} className={cn("relative")}>
      {image_link ? (
        <Image
          src={image_link}
          fill
          objectFit="cover"
          alt={name}
          className="grayscale filter"
        />
      ) : (
        <PlaceholderImage />
      )}
    </AspectRatio>
  );
}
